<template>
  <section-page
    title="Costs"
  >
    <template v-slot:right>
      <filter-field-default
        label="sort by"
        v-model="sortBy"
      >
        <option
          v-for="option in sortOptions"
          :key="option.value"
          :value="option.value"
        >{{ option.label }}
        </option>
      </filter-field-default>

      <filter-button-add @click="openCreateCostModal()">New Cost</filter-button-add>
    </template>

    <table-default :table-data="costsFormatted">
      <b-table-column
        label="Name"
        field="label"
        v-slot="props"
      >{{ props.row.label }}
      </b-table-column>

      <b-table-column
        label="Date"
        field="date"
        width="100"
        v-slot="props"
      >{{ formatDate(props.row.date) }}
      </b-table-column>

      <b-table-column
        label="Amount"
        field="amount"
        width="140"
        numeric
        v-slot="props"
      >{{ formatCurrency(props.row.amount) }}
      </b-table-column>

      <b-table-column
        label="Description"
        field="description"
        v-slot="props"
      >
        <div v-html="truncateDescription(props.row.description)"></div>
      </b-table-column>

      <b-table-column
        cell-class="has-text-right"
        width="70"
        v-slot="props"
      >
        <button-link @click="openEditCostModal(props.row)">Manage</button-link>
      </b-table-column>
    </table-default>

    <modal-container>
      <modal-crud-form
        ref="campaignCostModal"
        title="Campaign Cost"
        :collection.sync="costs"
        form-component="campaign-cost-form"
      ></modal-crud-form>
    </modal-container>
  </section-page>
</template>

<script>
import {computed} from "vue";
import {useCampaignStore} from "../campaigns.store";
import utils from "../../../services/utils";
import dates from "../../../services/dates";

export default {
  name: "CampaignCosts",
  setup() {
    const campaignStore = useCampaignStore();

    const costs = computed(() => campaignStore.sortedCosts);

    const costsFormatted = computed(() => {
      return costs.value.map((cost) => {
        return {
          ...cost,
          date: dates.convertDatetimeToISO(dates.addUserTimezone(cost.date))
        };
      });
    })

    const sortOptions = computed(() => campaignStore.filterOptions.costSorting);
    const sortBy = computed({
      get() {
        return campaignStore.filters.costs.sortBy
      },
      set(newValue) {
        campaignStore.setCostsSortBy(newValue)
      }
    })

    function openCreateCostModal() {
      this.$refs.campaignCostModal.open({campaign_id: campaignStore.activeCampaign.id});
    }

    function openEditCostModal(cost) {
      this.$refs.campaignCostModal.open(cost)
    }

    function formatCurrency(value) {
      return utils.formatCurrency(value);
    }

    function formatDate(timestamp) {
      return dates.formatAsDate(timestamp);
    }

    function truncateDescription(description) {
      return utils.truncateString(description, 100)
    }

    return {
      costs,
      costsFormatted,
      sortOptions,
      sortBy,
      openCreateCostModal,
      openEditCostModal,
      formatCurrency,
      formatDate,
      truncateDescription,
    };
  },
};
</script>
